import { memo } from 'react';
import { Box, FelaCSS } from '@bridebook/ui';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import componentStyles from './video-embed.style';

interface IProps {
  videoUrl: string;
  style?: FelaCSS;
}

const VideoEmbed = ({ videoUrl, style }: IProps) => {
  const styles = componentStyles();

  return (
    <Box style={mergeStyles([styles.wrapper, style || {}])}>
      <iframe
        width="100%"
        height="100%"
        style={styles.iframe}
        allowFullScreen
        src={videoUrl}
        loading="lazy"
      />
    </Box>
  );
};

export default memo(VideoEmbed);
